// extracted by mini-css-extract-plugin
export default {"admin-page":"AdminV2_admin-page__rVhvP"};